import { cn } from '@/lib/utils';
export const UppbeatLogoMission = () => <div className={cn('mt-4 w-full font-sans text-sm md:mt-0 md:text-xs', '@xl:max-w-[32rem] xl:max-w-[21rem]')} data-sentry-component="UppbeatLogoMission" data-sentry-source-file="UppbeatLogoMission.tsx">
    <p className="text-pretty text-gray-700 md:text-xs 2xl:text-sm dark:text-gray-200">
      Uppbeat is the essential creative resource - built for creators, powered
      by fairly-paid artists. Discover world-class music, sound effects, stock
      video, motion graphics and LUTs for every project.
    </p>
  </div>;